import type { TabType } from 'app/components/Tabs'
import { FORM_EDITOR_PATH } from './useFormsList'
import { PACKET_EDITOR_PATH } from './usePacketsList'

export const FORMS_SECTION_TABS: TabType[] = [
  { name: `Forms`, href: FORM_EDITOR_PATH },
  { name: `Packets`, href: PACKET_EDITOR_PATH },
]
